export default "__VITE_ASSET__nIx4PTR3__"